import BreadCrumb from "Components/Common/BreadCrumb";
import React from "react";
import { Row, Col, Container } from "reactstrap";
import Filters from "../Filters";
import TotalSupport from "../Widgets/TotalSupport";
import TotalContracts from "../Widgets/TotalContracts";
import TotalMDAs from "../Widgets/TotalMDAs";
import TotalPartners from "../Widgets/TotalPartners";
import AgencyCategoryDistribution from "./AgencyCategoryDistribution";

const ReportingAgenciesReport = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Reporting Agencies Report"
            pageTitles={[
              { title: "Dashboard", link: "/dashboard" },
              { title: "Reports" },
            ]}
          />

          <Row>
            <Col lg={12}>
              <Filters />
            </Col>
          </Row>

          <Row>
            <Col lg={3} md={4}>
              <TotalSupport />
            </Col>
            <Col lg={3} md={4}>
              <TotalContracts />
            </Col>
            <Col lg={3} md={4}>
              <TotalMDAs />
            </Col>
            <Col lg={3} md={4}>
              <TotalPartners />
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <AgencyCategoryDistribution />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ReportingAgenciesReport;
